import Bubble from "./Bubble";

export default function LinkBubble ({ 
    href, 
    ariaLabel,
    className = '',
    size = '48px',
    spawnOnVisible = true,
    children 
}) {
    return (
        <Bubble size={size} className={className} spawnOnVisible={spawnOnVisible}>
            <a 
                className="d-flex h-100 w-100 align-items-center justify-content-center"
                href={href} 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label={ariaLabel}
            >
                {children}
            </a>
        </Bubble>
    );
}